import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { FormControl, FormGroup, Input } from 'rsuite';
import { fetchProductFiltersList } from '../api';
import { useLocation } from '../hooks/useLocation';
import { EquipmentContext } from '../utils/scope';
import { CategoriesCombo } from './CategoriesCombo';
import { Filter } from './Filter';

export const SideFilters = () => {
  const {
    params: { s, category },
    go,
  } = useLocation();

  const scope = useContext(EquipmentContext);

  const [search, setSearch] = useState(s || '');

  useEffect(() => {
    setSearch(s || '');
  }, [s, setSearch]);

  const { data } = useQuery([scope, 'product-filters', category], fetchProductFiltersList);

  return (
    <>
      <FormGroup>
        <FormControl
          className="nh-search"
          // style={{ width: 100 }}
          placeholder={'Search...'}
          accepter={Input}
          value={search}
          onChange={setSearch}
          onPressEnter={() => {
            go({ s: search });
          }}
        />
        <CategoriesCombo />
        {[{ field: 'checkbox', name: 'in-stock', text: 'In Stock' }, ...(data?.filters || [])].map(
          (filter) => (
            <Filter label key={filter.name} filter={filter} />
          ),
        )}
      </FormGroup>
    </>
  );
};
